const DomUtils = require('../../util/dom_utils');
import LanguageManager from '../language_manager/language_manager';

export default {

    /**
     * @param {Object} options
     * @param {String} options.message
     * @param {Object} options.attachToElement - The element to attach the error to.
     * @param {String} [options.title]
     * @param {String} [options.redirect_message],
     * @param {Number} [options.seconds],
     * @constructor
     */
    show(options) {
        if (options.redirect_message) {
            options.redirect_message = LanguageManager.get('redirect_timeout').replace('{{seconds}}',
                `<span id="countdown">${parseInt(options.seconds || 5)}</span>`);

            this._startCountdown();
        }
        const html = DomUtils.createElementFromString(require('./error_screen.hbs')(options));

        options.attachToElement.appendChild(html);
    },

    hide() {
        DomUtils.removeChildrenOfElement(document.getElementsByClassName('player-error'));
    },

    _startCountdown() {
        const interval = setInterval(() => {
            const countElem = document.getElementById('countdown');
            let count = parseInt(document.getElementById('countdown').innerHTML);
            if (!isNaN(count) && count > 0) {
                countElem.innerHTML = parseInt(count - 1);
            } else {
                clearInterval(interval);
            }
        }, 1000);
    }
};



// WEBPACK FOOTER //
// ./src/modules/error_screen/error_screen.js